import { CommentOutlined, FormOutlined, ReloadOutlined } from "@ant-design/icons";
import { Button, Empty, Modal, Typography } from "antd";
import { useCallback, useState } from "react";
import handsImage from "./images/hands.png";
import signImage from "./images/sign.png";
import { OrderStatus } from "./orderStatus";
import classes from "./styles.module.css";
import {
  BgBankOrder,
  BgCart,
  fetchOrderModelByComponent,
  OrderModelResponse,
  CommentsComponentModel
} from "@services/api";
import { useAuthContext } from "@app/authContext";
import { Comments } from "@app/comments/Comments";
import { bxOpenSlider } from "@lib/bx24";
import { useOrderFormContext } from "@app/orderInfo";

const { Text } = Typography;
const copyableConfig = {
  tooltips: false,
};

type ComponentModel = {
  carts: BgCart[];
  orders: BgBankOrder[];
};

export const RelatedBankOrders = ({ carts, orders }: ComponentModel) => {
  const { auth } = useAuthContext();
  const accessToken = auth?.access_token;

  const { reloadOrder } = useOrderFormContext();

  const [open, setOpen] = useState(false);
  const [comments, setComments] = useState<CommentsComponentModel[]>([]);

  const showComments = useCallback(
    (orderId: string) => async () => {
      if (!accessToken) return;

      try {
        const res: OrderModelResponse = await fetchOrderModelByComponent(
          orderId,
          "comments",
          accessToken
        );
        setComments(res.components.comments || []);
        setOpen(true);
      } catch (e) {
        console.error(e);
      }
    },
    [accessToken]
  );

  if (!orders.length) return <Empty description='Заявка в обработке, нажмите кнопку "Обновить"'><Button type="primary" icon={<ReloadOutlined />} onClick={reloadOrder}>Обновить</Button></Empty>;

  return (
    <>
      <Modal
        open={open}
        onCancel={() => setOpen(false)}
        footer={null}
        title="Комментарии"
        width="fit-content"
        style={{ maxWidth: "90vw" }}
        bodyStyle={{ maxHeight: "72vh", overflowY: "auto", padding: 16 }}
      >
        <Comments comments={comments} compact onViewAll={() => { setOpen(false); bxOpenSlider('comments', comments || []); }} />
      </Modal>

      <div className={classes.bankOrders}>
        <div className={classes.statusesWrapper}>
          <div className={classes.infoCol}></div>
          <div className={classes.cartsTitles}>
            {carts.map(({ name }) => (
              <div key={name}>{name}</div>
            ))}
          </div>
          <div className={classes.commentCol}></div>
        </div>

        {orders.map((order) => (
          <div key={order.orderId} className={classes.bankRow}>
            <div className={classes.infoCol}>
              <div className={classes.bankName}>
                <span>{order.bankName}</span>
                <Button
                  size="small"
                  type="text"
                  icon={<FormOutlined />}
                  title="Детали по заявке"
                  aria-label="Детали по заявке"
                  onClick={() => { bxOpenSlider('bankOrder', { orderId: order.orderId }) }}
                />
                <span className={classes.markers}>
                  {order.applicationSigned && (
                    <img src={signImage} alt="Подписано" title="Подписано" />
                  )}
                  {order.applicationApproved && (
                    <img src={handsImage} alt="Одобрено" title="Одобрено" />
                  )}
                </span>
              </div>

              {order.externalOrderNumber && (
                <div className={classes.bankNumber}>№ {order.externalOrderNumber}</div>
              )}
            </div>

            <div className={classes.progressCol}>
              <OrderStatus status={order.status} carts={carts} order={order} />
              <div className={classes.taskWrapper}>
                {/* <div
                  className={classNames({ [classes.taskLink]: Boolean(order.taskId) })}
                  onClick={handleOpenTask(order.taskId)}
                >
                  <span>{order.taskDescription || (order.taskId ? "Доработать заявку" : "")}</span>
                  {order.taskId && (
                    <span className={classes.linkIcon}>
                      <ArrowUpOutlined />
                    </span>
                  )}
                </div> */}

                {order.externalTaskUrl && (
                  <Text
                    className={classes.extTaskUrl}
                    copyable={{ ...copyableConfig, text: order.externalTaskUrl }}
                  >
                    Ссылка на подписание
                  </Text>
                )}
              </div>
            </div>

            <div className={classes.commentCol}>
              <Button
                size="small"
                type="text"
                className={classes.commentsBtn}
                icon={<CommentOutlined />}
                title="Комментарии"
                aria-label="Комментарии"
                onClick={showComments(order.orderId)}
              />
            </div>
          </div>
        ))}
      </div>
    </>
  );
};
